module.exports = __webpack_public_path__ + "static/media/arrow-down-white.b945de6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/arrow-down-white.svg
// module id = 749
// module chunks = 0